export default __webpack_public_path__ + "static/media/_1080571.e5d4eb68.webp";